import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, Image, Settings, Mail, LogOut, Palette, ExternalLink, ShieldCheck } from "lucide-react";

const NAV = [
  { to: "/editor", label: "העמודים שלי", icon: LayoutGrid, exact: true },
  { to: "/editor/media", label: "ספריית מדיה", icon: Image },
  { to: "/editor/messages", label: "פניות", icon: Mail },
  { to: "/editor/admins", label: "מורשי גישה", icon: ShieldCheck },
  { to: "/editor/settings", label: "הגדרות ומעקב", icon: Settings },
];

export default function EditorLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (item) =>
    item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div dir="rtl" data-testid="editor-rtl-wrapper" className="font-editor editor-shell min-h-screen flex text-[#1A1D1A]">
      <aside className="w-72 shrink-0 bg-white border-l border-[#E5E2D9] flex flex-col fixed inset-y-0 right-0">
        <div className="p-6 border-b border-[#E5E2D9] flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#4A5D4E] flex items-center justify-center">
            <Palette className="w-5 h-5 text-white" strokeWidth={1.6} />
          </div>
          <div>
            <p className="font-bold text-[#1A1D1A] leading-tight">EmotionalSignal</p>
            <p className="text-xs text-[#5C635C]">ניהול האתר</p>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {NAV.map((item) => {
            const Icon = item.icon;
            const active = isActive(item);
            return (
              <Link key={item.to} to={item.to} data-testid={`sidebar-${item.to.split("/").pop() || "pages"}`}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${
                      active ? "bg-[#4A5D4E] text-white" : "text-[#1A1D1A] hover:bg-[#F7F5F0]"
                    }`}>
                <Icon className="w-5 h-5" strokeWidth={1.7} />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
          <a href="/" target="_blank" rel="noreferrer" data-testid="sidebar-view-site"
             className="flex items-center gap-3 px-4 py-3 rounded-xl text-[#5C635C] hover:bg-[#F7F5F0] transition-colors">
            <ExternalLink className="w-5 h-5" strokeWidth={1.7} />
            <span className="font-medium">צפייה באתר החי</span>
          </a>
        </nav>

        <div className="p-4 border-t border-[#E5E2D9]">
          <div className="flex items-center gap-3 px-2 mb-3">
            {user?.picture ? (
              <img src={user.picture} alt="" className="w-9 h-9 rounded-full" />
            ) : (
              <div className="w-9 h-9 rounded-full bg-[#E5E2D9]" />
            )}
            <div className="min-w-0">
              <p className="text-sm font-semibold truncate">{user?.name}</p>
              <p className="text-xs text-[#5C635C] truncate">{user?.email}</p>
            </div>
          </div>
          <button onClick={doLogout} data-testid="logout-btn"
                  className="w-full flex items-center gap-2 justify-center text-sm text-[#5C635C] hover:text-[#8C3A3A] py-2 rounded-lg transition-colors">
            <LogOut className="w-4 h-4" /> התנתקות
          </button>
        </div>
      </aside>

      <main className="flex-1 mr-72 min-h-screen">
        <div className="max-w-4xl mx-auto px-8 py-10">{children}</div>
      </main>
    </div>
  );
}
